// extracted by mini-css-extract-plugin
module.exports = {"arrow":"arrow___2Xxvw","right":"right___3qarC","left":"left___pyD2T"};